<template>
  <div class="space-y-2">
    <label
        v-if="label"
        class="form-label"
        :for="id"
    >
        {{ label }}:
    </label>

    <select
        :id="id"
        ref="input"
        v-model="selected"
        v-bind="$attrs"
        class="form-select"
        :class="{ error: error }"
    >
      <slot />
    </select>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import id from '../../functions/id'

export default {
    inheritAttrs: false,
    props: {
        modelValue: [String, Number, Boolean],
        label: String,
        error: String,
    },
    emits: ['update:modelValue'],
    computed: {
        id() {
            return id(this.label)
        },
        selected: {
            get() {
                return this.modelValue
            },
            set(val) {
                this.$emit('update:modelValue', val)
            }
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
